import actionTypes from "./actionTypes";
import api from "./api";
import { buildReduxAccessLevelKey } from "./selectors";
export default {
    getPermissions: (objectId, entity) => ({
        type: actionTypes.GET_ACCESS_LEVELS,
        payload: {
            promise: () => api.getLevels(objectId, entity)
        },
        scope: `${actionTypes.GET_ACCESS_LEVELS}_${buildReduxAccessLevelKey(objectId, entity)}`
    }),
    setIsOpen: (isOpen) => ({
        type: actionTypes.SET_IS_OPEN,
        isOpen
    })
};
